var BaseDomain = /** @class */ (function () {
    function BaseDomain() {
    }
    return BaseDomain;
}());
export { BaseDomain };



//////////////////
// WEBPACK FOOTER
// ./src/core/domain/common/baseDomain.ts
// module id = 613
// module chunks = 50